import API from '../utils/API';
import { makeActionCreator, makeGenericActionCreator } from '../utils/reduxUtils';
import { PAGINATION_PAGE_SIZE } from '../utils/constants';
import { grpcUnaryCall } from "../utils/grpc/grpcUtils";
import { GetTrialLimitRequest, UpdateTrialLimitRequest } from '../utils/grpc/generated/Billsby.Protos/core/private/companies/company_pb';
import { CompanyServiceClient } from '../utils/grpc/generated/Billsby.Protos/core/private/companies/CompanyServiceClientPb';
import { ConfigConstants } from '../utils/config';
import { GetTrialBalanceRequest } from '../utils/grpc/generated/Billsby.Protos/revenues/private/company/company_pb';
import { CompanyServiceClient as RevenueCompanyServiceClient } from '../utils/grpc/generated/Billsby.Protos/revenues/private/company/CompanyServiceClientPb';

export const FETCH_COMPANIES_REQUEST = 'FETCH_COMPANIES_REQUEST';
export const FETCH_COMPANIES_SUCCESS = 'FETCH_COMPANIES_SUCCESS';
export const FETCH_COMPANIES_FAILURE = 'FETCH_COMPANIES_FAILURE';

export const FETCH_COMPANY_TRIAL_LIMIT_REQUEST = 'FETCH_COMPANY_TRIAL_LIMIT_REQUEST';
export const FETCH_COMPANY_TRIAL_LIMIT_SUCCESS = 'FETCH_COMPANY_TRIAL_LIMIT_SUCCESS';
export const FETCH_COMPANY_TRIAL_LIMIT_FAILURE = 'FETCH_COMPANY_TRIAL_LIMIT_FAILURE';

export const UPDATE_COMPANY_TRIAL_LIMIT_REQUEST = 'UPDATE_COMPANY_TRIAL_LIMIT_REQUEST';
export const UPDATE_COMPANY_TRIAL_LIMIT_SUCCESS = 'UPDATE_COMPANY_TRIAL_LIMIT_SUCCESS';
export const UPDATE_COMPANY_TRIAL_LIMIT_FAILURE = 'UPDATE_COMPANY_TRIAL_LIMIT_FAILURE';

export const FETCH_COMPANY_TRIAL_BALANCE_REQUEST = 'FETCH_COMPANY_TRIAL_BALANCE_REQUEST';
export const FETCH_COMPANY_TRIAL_BALANCE_SUCCESS = 'FETCH_COMPANY_TRIAL_BALANCE_SUCCESS';
export const FETCH_COMPANY_TRIAL_BALANCE_FAILURE = 'FETCH_COMPANY_TRIAL_BALANCE_FAILURE';

export const SET_COMPANIES_FIELD = 'SET_COMPANIES_FIELD';
type AllowedCompaniesReducerFields = 'searchedCompanies';
export const setCompaniesField = makeGenericActionCreator<AllowedCompaniesReducerFields>(SET_COMPANIES_FIELD);

export const RESET_COMPANIES = 'RESET_COMPANIES';
export const resetCompanies = makeActionCreator(RESET_COMPANIES, 'payload');

export const fetchCompanies = function(pageNumber: number, pageSize: number = PAGINATION_PAGE_SIZE, search: string = '', includeAll: boolean = true) {
  return {
    types: [FETCH_COMPANIES_REQUEST, FETCH_COMPANIES_SUCCESS, FETCH_COMPANIES_FAILURE],
    callAPI: () => API.fetchCompanies(pageNumber, pageSize, search)
  };
};

export const fetchCompanyTrialLimit = function (companyId: number) {
  const getTrialLimitRequest = new GetTrialLimitRequest();
  getTrialLimitRequest.setCompanyId(companyId);
  const companyServiceClient = new CompanyServiceClient(ConfigConstants.grpcBaseUrl);

  return ({
    types: [FETCH_COMPANY_TRIAL_LIMIT_REQUEST, FETCH_COMPANY_TRIAL_LIMIT_SUCCESS, FETCH_COMPANY_TRIAL_LIMIT_FAILURE],
    callAPI: () => grpcUnaryCall(getTrialLimitRequest, companyServiceClient, companyServiceClient.getTrialLimit)
  })
}

export const updateCompanyTrialLimit = function (companyId: number, trialLimit: number) {
  const updateTrialLimitRequest = new UpdateTrialLimitRequest();
  updateTrialLimitRequest.setCompanyId(companyId);
  updateTrialLimitRequest.setTrialLimit(trialLimit);
  const companyServiceClient = new CompanyServiceClient(ConfigConstants.grpcBaseUrl);

  return ({
    types: [UPDATE_COMPANY_TRIAL_LIMIT_REQUEST, UPDATE_COMPANY_TRIAL_LIMIT_SUCCESS, UPDATE_COMPANY_TRIAL_LIMIT_FAILURE],
    callAPI: () => grpcUnaryCall(updateTrialLimitRequest, companyServiceClient, companyServiceClient.updateTrialLimit)
  })
}

export const fetchCompanyTrialBalance = function (companyId: number) {
  const getTrialBalanceRequest = new GetTrialBalanceRequest();
  getTrialBalanceRequest.setCompanyId(companyId);
  const companyServiceClient = new RevenueCompanyServiceClient(ConfigConstants.grpcBaseUrl);

  return ({
    types: [FETCH_COMPANY_TRIAL_BALANCE_REQUEST, FETCH_COMPANY_TRIAL_BALANCE_SUCCESS, FETCH_COMPANY_TRIAL_BALANCE_FAILURE],
    callAPI: () => grpcUnaryCall(getTrialBalanceRequest, companyServiceClient, companyServiceClient.getTrialBalance)
  })
}